import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { triggersQueryKeys } from "./triggersQueryKeys";

/**
 * A realistic, dereferenced sample of every platform event type: the envelope,
 * every namespace root with a full record under it, and the ``root.path`` names
 * a condition or ``{{ }}`` template may use.
 *
 * The server builds it from a fixed scenario through the evaluator's own
 * namespace, so it changes only with a deploy; it is fetched once per session
 * and never considered stale.
 */
export function useEventSamples(orgId?: string) {
  const { triggerService } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: triggersQueryKeys.eventSamples(resolvedOrgId),
    queryFn: ({ signal }) =>
      triggerService.getEventSamples({ abortSignal: signal }),
    staleTime: Infinity,
  });
}
